import {
  MAX_MONTHS,
  MIN_MONTHS,
} from '~addListing/pages/PriceStep/utils/constants';

const clampMonths = (months: number) =>
  Math.min(Math.max(months, MIN_MONTHS), MAX_MONTHS);

export default clampMonths;
